/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';
import { JobsViewerMetadata    } from "@/screens/ide/jobs.viewer.metadata";
import { WindowService         } from "@/services/window.service";

/**
 *
 * @class WindowJobsAction
 *
 * @brief ensure jobs window is open
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class WindowJobsAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.jobs',
      type:  ActionType.Window_Jobs,
      label: 'Jobs',
      icon:  '<i class="fab fa-stack-overflow"></i>',
      tip:   'Ensure the jobs window is open'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[WindowJobsAction] executing...');

    this.windows.launchWindow(new JobsViewerMetadata(
      '',
      '',
      ''
    ));

    return true;
  }
}
